var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4246_17460",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4246_17460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 16.6668C9.54183 16.6668 9.14961 16.5038 8.8235 16.1777C8.49683 15.851 8.3335 15.4585 8.3335 15.0002C8.3335 14.5418 8.49683 14.1493 8.8235 13.8227C9.14961 13.4966 9.54183 13.3335 10.0002 13.3335C10.4585 13.3335 10.851 13.4966 11.1777 13.8227C11.5038 14.1493 11.6668 14.5418 11.6668 15.0002C11.6668 15.4585 11.5038 15.851 11.1777 16.1777C10.851 16.5038 10.4585 16.6668 10.0002 16.6668ZM10.0002 11.6668C9.54183 11.6668 9.14961 11.5035 8.8235 11.1768C8.49683 10.8507 8.3335 10.4585 8.3335 10.0002C8.3335 9.54183 8.49683 9.14933 8.8235 8.82266C9.14961 8.49655 9.54183 8.3335 10.0002 8.3335C10.4585 8.3335 10.851 8.49655 11.1777 8.82266C11.5038 9.14933 11.6668 9.54183 11.6668 10.0002C11.6668 10.4585 11.5038 10.8507 11.1777 11.1768C10.851 11.5035 10.4585 11.6668 10.0002 11.6668ZM10.0002 6.66683C9.54183 6.66683 9.14961 6.5035 8.8235 6.17683C8.49683 5.85072 8.3335 5.4585 8.3335 5.00016C8.3335 4.54183 8.49683 4.14961 8.8235 3.8235C9.14961 3.49683 9.54183 3.3335 10.0002 3.3335C10.4585 3.3335 10.851 3.49683 11.1777 3.8235C11.5038 4.14961 11.6668 4.54183 11.6668 5.00016C11.6668 5.4585 11.5038 5.85072 11.1777 6.17683C10.851 6.5035 10.4585 6.66683 10.0002 6.66683Z",
    fill: "#333333"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.2adf1d340dd7ebf71444e876a1b51484.svg";
export { ForwardRef as ReactComponent };